import React from 'react'
import { Button, Skeleton, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import FilterButton, { FilterButtonProps } from './FilterButtonMui'

type Props = {
  categoryTitle: string
  filters: Array<Omit<FilterButtonProps, 'loading'>>
  onFilterChange?: (filterCategory: string, filter: string) => void
  onClearAll?: () => void
  loading: boolean
}

const FilterCategory: React.FC<Props> = ({
  categoryTitle,
  filters,
  loading,
  onFilterChange = () => {},
  onClearAll = () => {},
}) => {
  const { t } = useTranslation()

  const handleClick = (category: string, value: string) => {
    onFilterChange(category, value)
  }

  return (
    <Stack spacing={1} direction="column">
      <Stack alignItems="center" direction="row" justifyContent="space-between">
        <Typography variant="subtitle3">{categoryTitle}</Typography>
        <Button
          sx={{ width: 'fit-content' }}
          size="small"
          variant="text"
          onClick={() => onClearAll()}
          disabled={!filters.length}
        >
          {t('clearAll') || 'Clear all'}
        </Button>
      </Stack>
      {loading && !filters.length ? (
        <Skeleton variant="rectangular" width="100%" height={65} />
      ) : null}
      {filters.map((filter) => (
        <FilterButton
          loading={loading}
          selected={filter.selected}
          category={filter.category}
          backgroundColor={filter.backgroundColor}
          backgroundIcon={filter.backgroundIcon}
          value={filter.value}
          onClick={(category, value) => handleClick(category, value)}
          key={filter.value}
          title={filter.title}
          quantity={filter.quantity}
          backgroundImageUrl={filter.backgroundImageUrl}
          subtitle={filter.subtitle}
        />
      ))}
    </Stack>
  )
}

export default FilterCategory
